//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

export enum StreamsDrawerActionNames {
  ADD_ITEMS = 'STREAMS_DRAWER/ADD_ITEMS',
  ADD_MODAL_SELECT_GALLERY = 'STREAMS_DRAWER/ADD_MODAL_SELECT_GALLERY',
  ADD_MODAL_DESELECT_GALLERY = 'STREAMS_DRAWER/ADD_MODAL_DESELECT_GALLERY',
  CLOSE_FILTERS_SIDEBAR = 'STREAMS_DRAWER/CLOSE_FILTERS_SIDEBAR',
  CLOSE_CONTENT_DISCOVERY_FIRST_RUN = 'STREAMS_DRAWER/CLOSE_CONTENT_DISCOVERY_FIRST_RUN',
  CLOSE_REMOVAL_CONFIRMATION_MODAL = 'STREAMS_DRAWER/CLOSE_REMOVAL_CONFIRMATION_MODAL',
  CLOSE_STREAM_MODAL = 'STREAMS_DRAWER/CLOSE_STREAM_MODAL',
  CLOSE_STREAMS_DRAWER = 'STREAMS_DRAWER/CLOSE_STREAMS_DRAWER',
  DELETE_TBB_AUTOMATION_CONFIGURATION_SUCCEEDED = 'STREAMS_DRAWER/DELETE_TBB_AUTOMATION_CONFIGURATION_SUCCEEDED',
  DELETE_TBB_AUTOMATION_CONFIGURATION_FAILED = 'STREAMS_DRAWER/DELETE_TBB_AUTOMATION_CONFIGURATION_FAILED',
  DISCARD_RECEIVED_CONTENT_ITEMS = 'STREAMS_DRAWER/DISCARD_RECEIVED_CONTENT_ITEMS',
  FINISH_REFRESHING_STREAMS = 'STREAMS_DRAWER/FINISH_REFRESHING_STREAMS',
  OPEN_FILTERS_SIDEBAR = 'STREAMS_DRAWER/OPEN_FILTERS_SIDEBAR',
  OPEN_REMOVAL_CONFIRMATION_MODAL = 'STREAMS_DRAWER/OPEN_REMOVAL_CONFIRMATION_MODAL',
  OPEN_STREAM_MODAL = 'STREAMS_DRAWER/OPEN_STREAM_MODAL',
  OPEN_DELETE_STREAM_CONFIRMATION_MODAL = 'STREAMS_DRAWER/OPEN_DELETE_STREAM_CONFIRMATION_MODAL',
  CLOSE_DELETE_STREAM_CONFIRMATION_MODAL = 'STREAMS_DRAWER/CLOSE_DELETE_STREAM_CONFIRMATION_MODAL',
  OPEN_AUTO_APPROVAL_ENTRY_MODAL = 'STREAMS_DRAWER/OPEN_AUTO_APPROVAL_ENTRY_MODAL',
  CLOSE_AUTO_APPROVAL_ENTRY_MODAL = 'STREAMS_DRAWER/CLOSE_AUTO_APPROVAL_ENTRY_MODAL',
  OPEN_AUTO_APPROVAL_MODAL = 'STREAMS_DRAWER/OPEN_AUTO_APPROVAL_MODAL',
  CLOSE_AUTO_APPROVAL_MODAL = 'STREAMS_DRAWER/CLOSE_AUTO_APPROVAL_MODAL',
  OPEN_STREAMS_DRAWER = 'STREAMS_DRAWER/OPEN_STREAMS_DRAWER',
  OPEN_REJECTION_REASONS_MODAL = 'STREAMS_DRAWER/OPEN_REJECTION_REASONS_MODAL',
  CLOSE_REJECTION_REASONS_MODAL = 'STREAMS_DRAWER/CLOSE_REJECTION_REASONS_MODAL',
  RECEIVE_BRAND_INSTAGRAM_FAILED = 'STREAMS_DRAWER/RECEIVE_BRAND_INSTAGRAM_FAILED',
  RECEIVE_BRAND_INSTAGRAM_SUCCEEDED = 'STREAMS_DRAWER/RECEIVE_BRAND_INSTAGRAM_SUCCEEDED',
  REQUEST_CLIENT_REJECTION_REASONS = 'STREAMS_DRAWER/REQUEST_CLIENT_REJECTION_REASONS',
  RECEIVE_CLIENT_REJECTION_REASONS_FAILED = 'STREAMS_DRAWER/RECEIVE_CLIENT_REJECTION_REASONS_FAILED',
  RECEIVE_CLIENT_REJECTION_REASONS_SUCCEEDED = 'STREAMS_DRAWER/RECEIVE_CLIENT_REJECTION_REASONS_SUCCEEDED',
  RECEIVE_BRAND_FACEBOOK_FAILED = 'STREAMS_DRAWER/RECEIVE_BRAND_FACEBOOK_FAILED',
  RECEIVE_BRAND_FACEBOOK_SUCCEEDED = 'STREAMS_DRAWER/RECEIVE_BRAND_FACEBOOK_SUCCEEDED',
  RECEIVE_FIRST_RUN_STATUS_SUCCEEDED = 'STREAMS_DRAWER/RECEIVE_FIRST_RUN_STATUS_SUCCEEDED',
  RECEIVE_CLIENT_TBB_AUTOMATION_CONFIGURATION_FAILED = 'STREAMS_DRAWER/RECEIVE_CLIENT_TBB_AUTOMATION_CONFIGURATION_FAILED',
  RECEIVE_CLIENT_TBB_AUTOMATION_CONFIGURATION_SUCCEEDED = 'STREAMS_DRAWER/RECEIVE_CLIENT_TBB_ACTIVE_AUTOMATION_CONFIGURATION_SUCCEEDED',
  RECEIVE_CLIENT_TBB_ACTIVE_NO_AUTOMATION_CONFIGURATION = 'STREAMS_DRAWER/RECEIVE_CLIENT_TBB_ACTIVE_NO_AUTOMATION_CONFIGURATION',
  RECEIVE_CLIENT_TBB_ACTIVE_AUTOMATION_CONFIGURATION_SUCCEEDED = 'STREAMS_DRAWER/RECEIVE_CLIENT_TBB_AUTOMATION_CONFIGURATION_SUCCEEDED',
  UPDATE_ITEMS_IN_PLACE = 'STREAMS_DRAWER/UPDATE_ITEMS_IN_PLACE',
  RECEIVE_CONTENT_ITEMS_SUCCEEDED = 'STREAMS_DRAWER/RECEIVE_CONTENT_ITEMS_SUCCEEDED',
  RECEIVE_FILTERED_CONTENT_ITEMS_SUCCEEDED = 'STREAMS_DRAWER/RECEIVE_FILTERED_CONTENT_ITEMS_SUCCEEDED',
  RECEIVE_NEXT_CONTENT_ITEMS_SUCCEEDED = 'STREAMS_DRAWER/RECEIVE_NEXT_CONTENT_ITEMS_SUCCEEDED',
  RECEIVE_SUMMARY_ITEMS_SUCCEEDED = 'STREAMS_DRAWER/RECEIVE_SUMMARY_ITEMS_SUCCEEDED',
  SET_TAGGED_BY_CURALATE_PENDING_COUNT = 'STREAMS_DRAWER/SET_TAGGED_BY_CURALATE_PENDING_COUNT',
  SET_CONNECT_PENDING_COUNT = 'STREAMS_DRAWER/SET_CONNECT_PENDING_COUNT',
  REMOVE_ITEMS = 'STREAMS_DRAWER/REMOVE_ITEMS',
  REQUEST_BRAND_INSTAGRAM = 'STREAMS_DRAWER/REQUEST_BRAND_INSTAGRAM',
  REQUEST_BRAND_FACEBOOK = 'STREAMS_DRAWER/REQUEST_BRAND_FACEBOOK',
  REQUEST_FIRST_RUN_STATUS = 'STREAMS_DRAWER/REQUEST_FIRST_RUN_STATUS',
  REQUEST_CONTENT_ITEMS = 'STREAMS_DRAWER/REQUEST_CONTENT_ITEMS',
  REQUEST_FILTERED_CONTENT_ITEMS = 'STREAMS_DRAWER/REQUEST_FILTERED_CONTENT_ITEMS',
  REQUEST_NEXT_CONTENT_ITEMS = 'STREAMS_DRAWER/REQUEST_NEXT_CONTENT_ITEMS',
  REQUEST_SUMMARY_ITEMS = 'STREAMS_DRAWER/REQUEST_SUMMARY_ITEMS',
  RESET_ASSET_FEEDS_DRAWER = 'STREAMS_DRAWER/RESET_ASSET_FEEDS_DRAWER',
  SELECT_STREAM = 'STREAMS_DRAWER/SELECT_STREAM',
  SET_CREATOR_CLIENTS = 'STREAMS_DRAWER/SET_CREATOR_CLIENTS',
  SET_ASSET_FEEDS_ONBOARDING = 'STREAMS_DRAWER/SET_ASSET_FEEDS_ONBOARDING',
  SET_CONTENT_DISCOVERY_FLAG = 'STREAMS_DRAWER/SET_CONTENT_DISCOVERY_FLAG',
  SET_CONTENT_VIEW = 'STREAMS_DRAWER/SET_CONTENT_VIEW',
  SET_END_OF_CONTENT_REACHED = 'STREAMS_DRAWER/SET_END_OF_CONTENT_REACHED',
  SET_FILTERS = 'STREAMS_DRAWER/SET_FILTERS',
  SET_LAST_SAVED_FILTERS = 'STREAMS_DRAWER/SET_LAST_SAVED_FILTERS',
  SET_SELECTED_STREAM_TYPE = 'STREAMS_DRAWER/SET_SELECTED_STREAM_TYPE',
  SET_REQUEST_CONTENT_NONCE = 'STREAMS_DRAWER/SET_REQUEST_CONTENT_NONCE',
  SET_SOURCES = 'STREAMS_DRAWER/SET_SOURCES',
  SET_STREAMS = 'STREAMS_DRAWER/SET_STREAMS',
  SET_CURRENT_STREAM_NAME = 'STREAMS_DRAWER/SET_CURRENT_STREAM_NAME',
  SET_SORT = 'STREAMS_DRAWER/SET_SORT',
  SET_MENTIONS_MY_BRAND = 'STREAMS_DRAWER/SET_MENTIONS_MY_BRAND',
  SET_MODERATION_STATUS = 'STREAMS_DRAWER/SET_MODERATION_STATUS',
  SET_CONNECT_VENDOR = 'STREAMS_DRAWER/SET_CONNECT_VENDOR',
  SET_RECOMMENDATIONS_STREAMS = 'STREAMS_DRAWER/SET_RECOMMENDATIONS_STREAMS',
  SET_TRACKING_SOURCE_TIMEOUT = 'STREAMS_DRAWER/SET_TRACKING_SOURCE_TIMEOUT',
  START_REFRESHING_STREAMS = 'STREAMS_DRAWER/START_REFRESHING_STREAMS',
}
